import { ConfirmationService } from 'primeng/components/common/api';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { SelectItem } from 'primeng/primeng';
import * as FileSaver from 'file-saver';
import { PromotionReportService } from 'app/services/promotion/promotion-report.service';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';

@Component({
  selector: 'app-promo-report-list',
  templateUrl: './promo-report-list.component.html',
  styleUrls: ['./promo-report-list.component.css']
})
export class PromoReportListComponent implements OnInit {
  paginationType = KontableComponent.ServerPagination;
  selectFilter = KontableComponent.SelectFilter;
  dateFilter = KontableComponent.DateFilter;
  translationsReady:boolean=false;


  //TODO aggiungere uno stato con C
  reportStates: SelectItem[] = [];
  showModal = false;
  @ViewChild('table') table: Campaign3KontableComponent;

  constructor(
    public reportService: PromotionReportService,
    private translateService: TranslateService,
    private confirmationService: ConfirmationService
  ) { }
  ngOnInit() {
    this.translateService.get([
      'common.all',
      'report.generated',
      'report.onError',
      'report.downloadReady',
      'report.onExecution',
      'report.creation',
      'report.withoutData'
    ]).subscribe(translations => {
      this.reportStates = [
        { label: translations['common.all'], value: null },
        { label: translations['report.generated'], value: "0" },
        { label: translations['report.onError'], value: "E" },
        { label: translations['report.downloadReady'], value: "P" },
        { label: translations['report.onExecution'], value: "A" },
        { label: translations['report.creation'], value: "C" },
        { label: translations['report.withoutData'], value: "z" }
      ];
      this.translationsReady = true;
    });
  }

  downloadPromoReport(reportQueryId: number) {
    const fileName = `report_query_id_${reportQueryId}.csv`;
    this.reportService.downloadPromoReport(fileName)
      .subscribe(res => FileSaver.saveAs(res, fileName));
  }
  
  openModal() {
    this.showModal = true;
  }

  closeModal() {
    this.showModal = false;
  }

  onSaveReport() {
    this.table.refresh();
    this.closeModal();
  }

  showProcessingDetail(detailMsg: string) {
    console.log(detailMsg);
    this.confirmationService.confirm({
      header: this.translateService.instant('report.processingDetail'),
      message:  this.translateService.instant('report.reportCreated'),
      acceptLabel: 'Ok',
      rejectVisible: false
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/promotion/report/promo-report-list/promo-report-list.component.ts